module.exports = __webpack_public_path__ + "img/Event1.1c1a423f.jpg";